<template>
        <div class="row justify-content-center">
            <div class="col-lg-5 col-md-7">
                <div v-if="errorMessage != null" id="errorNotification">
                    <base-alert type="danger">
                        <span class="alert-inner--text"> {{errorMessage}}</span> <br>
                        <span v-if="canClearExistingSession == true">Click <a @click="clearExistingSession"><u>here</u></a> to remove existing session</span>
                    </base-alert>
                </div>
                 <div v-else-if="successMessage != null">
                    <base-alert type="success">
                        <span class="alert-inner--text"> {{successMessage}}</span> <br>
                    </base-alert>
                </div>
                <div class="card bg-secondary shadow border-0"> 
                    <div class="card-body px-lg-5 py-lg-5">
                        <h1>Log in</h1> <br>
                        <form role="form">
                            <base-input class="input-group-alternative mb-3"
                                        placeholder="Username/Email"
                                        addon-left-icon="ni ni-email-83"
                                        v-model="email">
                            </base-input>

                            <base-input class="input-group-alternative mb-3"
                                        placeholder="Password"
                                        type="password"
                                        addon-left-icon="ni ni-lock-circle-open"
                                        v-model="password">
                            </base-input>

                            <div class="text-center">
                                <base-button type="primary" class="my-4" @click.prevent="authenticateUser">Sign in</base-button><br>
                                <a class="text-dark"><small>Forgot password?</small></a>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import HTTPRequest from '../controllers/httpRequest.js'
import secureStorage from '../controllers/secureStorage.js'
import { mapState, mapActions } from 'vuex'
import axios from "axios";

import Fingerprint2 from 'fingerprintjs2'

var options = {}
var browserId = ""

var navigate, component_x;
export default {
    computed: {
        ...mapState(['loggedIn', 'endPoint', 'userEmail']),
    },
    mounted: function(){
        navigate = this.$router;
        component_x = this;
        secureStorage.setItem("developerMode", true);
        secureStorage.setItem("isRippleAdmin", false);
        secureStorage.setItem("isAccountOwner", false);
        if (window.requestIdleCallback) {
            requestIdleCallback(function () {
                 Fingerprint2.get(options, async function (components) {
                    var values = components.map(function (component) { return component.value })
                    var murmur = Fingerprint2.x64hash128(values.join(''), 31)
                    browserId = murmur
                    var autoLogin = await HTTPRequest.getRequest(component_x.endPoint + 'backend_sessions/developer_auto_login?machine_id=' + browserId, null, null)
                    if(autoLogin.status == true){
                    secureStorage.setItem("sessionId", autoLogin.backend_session.id)
                    secureStorage.setItem("userName", autoLogin.developer_account.email);
                    secureStorage.setItem("developerEmail", autoLogin.developer_account.email);
                    secureStorage.setItem("developerAccountId", autoLogin.developer_account.id);
                    navigate.push('/developer_dashboard');
                    component_x.$notification['info']({
                        message: 'Welcome to BXI',
                        description: "You still have an active session for this device."
                    });
                    }
                })
            })
        }
    },
    data: function() {
        return {
            email: '',
            password: '',
            errorMessage: null,
            successMessage: null,
            canClearExistingSession: false,
            clearUsername: '',
            clearAccountName: ''
        }
    },
    methods: {
        ...mapActions(['updateLoggedInStatus', 'updateUserEmail', 'updateDefaultSite']),
        async clearExistingSession(){
            var post_request = await HTTPRequest.postRequest(this.endPoint + 'backend_sessions/delete_existing_session?email='+this.clearUsername+'&is_developer=true', null, null)
            if (post_request.status == true) {
                this.errorMessage = null
                this.successMessage = 'You have successfully cleared your existing session, please login again.'
            } else {
                this.errorMessage = "Error clearing existing session"
                this.successMessage = null
            }
        },
        authenticateUser: async function() {
            if(this.email == null || this.password == null || this.email == '' || this.password == ''){
                component_x.errorMessage = "Email and password are both required fields for login."
            } else {
                var login_payload = {email: this.email, password: this.password}
                var developer_account = await HTTPRequest.postRequest(component_x.endPoint + 'developer_accounts/login', null, login_payload)
                if (developer_account.error){
                    component_x.errorMessage = developer_account.error
                } else {
                    secureStorage.setItem("developerMode", true);
                    secureStorage.setItem("userName", this.email);
                    secureStorage.setItem("developerEmail", this.email);
                    secureStorage.setItem("developerAccountId", developer_account.id);
                    component_x.errorMessage = null
                    var createSession = await HTTPRequest.postRequest(this.endPoint + 'backend_sessions/create_developer?user_id='+developer_account.id+'&machine_id=' + browserId, null, null)
                    if(createSession["error"] != undefined){
                        component_x.errorMessage = createSession["error"]
                        if (component_x.errorMessage == 'You still have an active session. Please logout.'){
                            component_x.canClearExistingSession = true
                            component_x.clearUsername = this.email
                        } else {
                            component_x.canClearExistingSession = false
                            component_x.clearUsername = ''
                        }
                    } else {
                        secureStorage.setItem("sessionId", createSession["id"])
                        secureStorage.setItem("developerMode", true);
                        secureStorage.setItem("userName",  createSession["email"]);
                        secureStorage.setItem("developerEmail",  createSession["email"]);
                        secureStorage.setItem("developerAccountId",  createSession["developer_account_id"]);
                        secureStorage.setItem("isAccountOwner", false)
                        navigate.push('/developer_dashboard');
                    }
                }
            }
        }
    }
}
</script>

<style>
</style>
